import React from "react";

const DimmingDotsLoader = (props) => {
  return (
    <>
      <div className="loader-new dimming-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  );
};

export default DimmingDotsLoader;
